import { CommonModule } from '@angular/common'
import {
    Component,
    HostBinding,
    HostListener,
    booleanAttribute,
    effect,
    input,
    model,
} from '@angular/core'
import { MatRipple } from '@angular/material/core'
import { TagType } from '@shared-ui-lib/tag/tag.model'

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    standalone: true,
    imports: [CommonModule],
    hostDirectives: [MatRipple],
})
export class TagComponent {
    readonly tagType = input<TagType>()
    selected = model(false)
    readonly disabled = input(false, {
        transform: booleanAttribute,
    })

    @HostBinding('class.primary') _primary = false
    @HostBinding('class.success') _success = false
    @HostBinding('class.caution') _caution = false
    @HostBinding('class.error') _error = false
    @HostBinding('class.info') _info = false
    @HostBinding('class.selected') _selected = false
    @HostBinding('class.disabled') _disabled = false

    @HostListener('click')
    onClick() {
        this.selected.update((value) => !value)
    }

    constructor() {
        effect(() => {
            this._selected = this.selected()
        })

        effect(() => {
            this._disabled = this.disabled()
        })

        effect(() => {
            this._primary =
                this._success =
                this._caution =
                this._error =
                this._info =
                    false

            switch (this.tagType()) {
                case 'primary':
                    this._primary = true
                    break
                case 'success':
                    this._success = true
                    break
                case 'caution':
                    this._caution = true
                    break
                case 'error':
                    this._error = true
                    break
                case 'info':
                    this._info = true
                    break
                default:
                    this._primary = true
                    break
            }
        })
    }
}
